export const CONCILIATION_STATUS = {
  COMPLETED: 'completed',
  CONFLICTING: 'conflicting'
}
